import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-grid",
  "use": "icon-grid-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" aria-labelledby=\"gridLargeIconTitle\" stroke=\"#000000\" stroke-width=\"2\" stroke-linecap=\"square\" stroke-linejoin=\"miter\" fill=\"none\" id=\"icon-grid\"> <title id=\"icon-grid_gridLargeIconTitle\">Large Grid</title> <rect width=\"7\" height=\"7\" x=\"3\" y=\"3\" /> <rect width=\"7\" height=\"7\" x=\"14\" y=\"3\" /> <rect width=\"7\" height=\"7\" x=\"3\" y=\"14\" /> <rect width=\"7\" height=\"7\" x=\"14\" y=\"14\" /> </symbol>"
});
var result = sprite.add(symbol);
export default symbol